import React from 'react'

import style from './style.scss'

export default function Title({ title }) {

	const formattedTitle = title.replace(/(?:\r\n|\r|\n)/g, '<br />')

  return (
    <div className={style.containerTitle}>
      <h2
        className={`${style.title} title title-color`}
        dangerouslySetInnerHTML={{ __html: formattedTitle }}
      />
    </div>
  )
}
